import axios from "axios";

export default {
  state: () => ({
    pagoMinimo: null,
  }),
  mutations: {
    setPagoMinimo(state, payload) {
      state.pagoMinimo = payload;
    },
  },
  actions: {
    async getPagoMinimo(context, { clienteId, periodo = null }) {
      const resp = await axios.get("/clientes/pago-minimo", {
        params: {
          cliente: clienteId,
          periodo: periodo,
        },
      });

      context.commit("setPagoMinimo", resp.data.TOTAL);
    },
  },
};
